const ACTIVE_TASK_TIMER_KEY = 'pm_active_task_timer';
const TIMER_EVENT_NAME = 'pmTaskTimerUpdated';

export const readActiveTaskTimer = () => {
  try {
    const raw = localStorage.getItem(ACTIVE_TASK_TIMER_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (error) {
    return null;
  }
};

export const writeActiveTaskTimer = (timerData) => {
  if (!timerData) {
    localStorage.removeItem(ACTIVE_TASK_TIMER_KEY);
  } else {
    localStorage.setItem(ACTIVE_TASK_TIMER_KEY, JSON.stringify(timerData));
  }
  window.dispatchEvent(new CustomEvent(TIMER_EVENT_NAME));
};

export const getActiveTaskTimerEventName = () => TIMER_EVENT_NAME;
